
import React from 'react';
import { Language } from '../../types';
import { t } from '../../i18n';

interface AppFooterProps {
    lang: Language;
    className?: string;
}

export const AppFooter: React.FC<AppFooterProps> = ({ lang, className = "" }) => {
    const links = [
        { label: t(lang, 'privacyPolicy'), href: '/privacy' },
        { label: t(lang, 'termsOfService'), href: '/terms' },
        { label: t(lang, 'helpCenter'), href: '/help' },
        { label: t(lang, 'apiAndCopyright'), href: '/api-info' }
    ];

    return (
        <footer className={`py-32 md:py-4 ${className}`}>
            <div className="max-w-4xl mx-auto flex flex-col items-center text-center">
                <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-4">
                    {links.map((link, i) => (
                        <button 
                            key={i} 
                            onClick={() => window.navigateTo(link.href)}
                            className="text-[11px] font-black uppercase tracking-widest text-slate-400 md:hover:text-rose-500 transition-colors"
                        >
                            {link.label}
                        </button>
                    ))}
                </div>
                <div className="space-y-3 px-6">
                    <p className="text-[9px] text-slate-300 font-medium">
                        Copyright © 2026 XLEVEN. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};
